var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, object-curly-spacing, react/jsx-closing-bracket-location, react/sort-comp, space-before-function-paren */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var Editor = require("../editor.jsx");
var RangeInput = require("../components/range-input.jsx");

var Matrix = require("./matrix.jsx").widget;

// Really large matrices will cause issues with question formatting, so we
// have to cap it at some point.
var MAX_BOARD_SIZE = 6;

var getMatrixSize = function getMatrixSize(matrix) {
    var matrixSize = [1, 1];

    // We need to find the widest row and tallest column to get the correct
    // matrix size.
    _(matrix).each(function (matrixRow, row) {
        var rowWidth = 0;
        _(matrixRow).each(function (matrixCol, col) {
            if (matrixCol != null && matrixCol.toString().length) {
                rowWidth = col + 1;
            }
        });

        // Matrix width:
        matrixSize[1] = Math.max(matrixSize[1], rowWidth);

        // Matrix height:
        if (rowWidth > 0) {
            matrixSize[0] = Math.max(matrixSize[0], row + 1);
        }
    });
    return matrixSize;
};

var MatrixEditor = React.createClass({
    displayName: "MatrixEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        matrixBoardSize: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
        answers: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.number)),
        prefix: React.PropTypes.string,
        suffix: React.PropTypes.string,
        cursorPosition: React.PropTypes.arrayOf(React.PropTypes.number)
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            matrixBoardSize: [3, 3],
            answers: [[]],
            prefix: "",
            suffix: "",
            cursorPosition: [0, 0]
        };
    },

    render: function render() {
        var _this = this;

        var matrixProps = _.extend({
            numericInput: true,
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            trackInteraction: function trackInteraction() {}
        }, this.props);
        return React.createElement(
            "div",
            { className: "perseus-matrix-editor" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                " ",
                "Max matrix size:",
                " ",
                React.createElement(RangeInput, {
                    value: this.props.matrixBoardSize,
                    onChange: this.onMatrixBoardSizeChange,
                    format: this.props.labelStyle,
                    useArrowKeys: true
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(Matrix, matrixProps)
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                " ",
                "Matrix prefix:",
                " ",
                React.createElement(Editor, {
                    ref: "prefix",
                    apiOptions: this.props.apiOptions,
                    content: this.props.prefix,
                    widgetEnabled: false,
                    onChange: function onChange(newProps) {
                        _this.change({ prefix: newProps.content });
                    }
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                " ",
                "Matrix suffix:",
                " ",
                React.createElement(Editor, {
                    ref: "suffix",
                    apiOptions: this.props.apiOptions,
                    content: this.props.suffix,
                    widgetEnabled: false,
                    onChange: function onChange(newProps) {
                        _this.change({ suffix: newProps.content });
                    }
                })
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    onMatrixBoardSizeChange: function onMatrixBoardSizeChange(range) {
        var _this2 = this;

        var matrixSize = getMatrixSize(this.props.answers);
        if (range[0] !== null && range[1] !== null) {
            range = [Math.round(Math.min(Math.max(range[0], 1), MAX_BOARD_SIZE)), Math.round(Math.min(Math.max(range[1], 1), MAX_BOARD_SIZE))];
            var answers = _(Math.min(range[0], matrixSize[0])).times(function (row) {
                return _(Math.min(range[1], matrixSize[1])).times(function (col) {
                    return _this2.props.answers[row][col];
                });
            });
            this.props.onChange({
                matrixBoardSize: range,
                answers: answers
            });
        }
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = MatrixEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/matrix-editor.jsx
 ** module id = 123
 ** module chunks = 0 1
 **/